import I18n from 'I18n';
import { fetchSocialBroadcastChannels, fetchSocialBroadcastPerformance } from './api';
export function getNonCrmPropertyValue(propertyName, nonCrmObject) {
  if (!nonCrmObject) {
    return undefined;
  }
  const socialBroadcastResponse = nonCrmObject;
  switch (propertyName) {
    default:
      return undefined;
    case 'channelKey':
      return socialBroadcastResponse.channelKey;
    case 'likes':
      return socialBroadcastResponse.likes;
  }
}
export function getSocialBroadcastPerformanceStats({
  crmObject,
  nonCrmObject
}) {
  return fetchSocialBroadcastChannels().then(socialChannels => {
    const hsChannelKey = getNonCrmPropertyValue('channelKey', nonCrmObject);
    return socialChannels.find(channel => channel.channelKey === `${hsChannelKey}`);
  }).then(socialChannel => {
    if (!socialChannel) {
      return Promise.resolve(undefined);
    }
    return fetchSocialBroadcastPerformance(crmObject, socialChannel);
  }).then(socialBroadcastStats => {
    if (!socialBroadcastStats) {
      return Promise.resolve([]);
    }
    const overviewPerfGroup = {
      stats: [{
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_clicks',
        value: socialBroadcastStats.stats.clicks
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_interactions',
        value: socialBroadcastStats.interactionsTotal
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_impressions',
        value: socialBroadcastStats.stats.impressions
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_comments',
        value: socialBroadcastStats.stats.comments
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-71.overview')
    };
    const socialPostPerformancePerfGroup = {
      stats: [{
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_likes',
        value: socialBroadcastStats.stats.likes
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_shares',
        value: socialBroadcastStats.stats.shares
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_network_clicks',
        value: socialBroadcastStats.stats.clicksNetwork
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_social_broadcast_reactions',
        value: socialBroadcastStats.stats.reactions
      }, {
        formatStyle: 'text',
        propertyName: 'hs_social_broadcast_source',
        value: I18n.text(socialBroadcastStats.broadcastGuid ? 'frameworkAssetPreviewLib.propertyValue.0-71.source.internal' : 'frameworkAssetPreviewLib.propertyValue.0-71.source.external')
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-71.socialPostPerformance')
    };
    return [overviewPerfGroup, socialPostPerformancePerfGroup];
  }).catch(() => Promise.resolve([]));
}